// extracted by mini-css-extract-plugin
export default {"cls1":"UserListMenu-cls1__7P","cls2":"UserListMenu-cls2__G8 UserListMenu-cls1__7P"};